import { API_ADMIN } from 'utils/constants'
import Api from './axiosInstance'
import axios from 'axios'

interface CloneInventoryPayload {
  fromStore: string
  toStores: string[]
  copyAllBarcode: boolean
  s3Key?: string
}

export interface ClonePricePayload extends CloneInventoryPayload {
  fromAggregator: string
  toAggregators: string[]
}

export const cloneInventoryToStoreApi = async (
  payload: CloneInventoryPayload,
  s3Key?: string,
) => {
  if (s3Key) {
    payload.s3Key = s3Key
  }

  const { data } = await Api.post({
    url: API_ADMIN.CLONE_INVENTORY,
    data: payload,
  })
  return data
}

export const clonePricingToStoreApi = async (
  payload: ClonePricePayload,
  s3Key?: string,
) => {
  if (s3Key) {
    payload.s3Key = s3Key
  }

  const { data } = await Api.post({ url: API_ADMIN.CLONE_PRICE, data: payload })
  return data
}

export const getUploadUrlToCloneInventoryPricing = async (payload: {
  fileName: string
  fileType: string
  module: string
}) => {
  const { data } = await Api.post({
    url: API_ADMIN.CLONE_PRESIGNED_URL,
    data: payload,
  })
  return data
}

interface UploadToS3Options {
  uploadUrl: string
  file: File
  onProgress?: (progress: number) => void
}

export const uploadFileToPresignedUrl = async ({
  uploadUrl,
  file,
  onProgress,
}: UploadToS3Options) => {
  return axios.put(uploadUrl, file, {
    headers: {
      'Content-Type': file.type,
    },
    onUploadProgress: (progressEvent) => {
      if (!onProgress || !progressEvent.total) return

      const percent = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total,
      )

      onProgress(percent)
    },
  })
}
